import * as yup from 'yup';

const foodAidValidationSchema = yup.object({
  petName: yup.string().required('required').min(2, 'required'),
});

export default foodAidValidationSchema;
